/**
 * DEPRECATED — Scheduled for removal.
 * Authority: DESIGN_INTENTS in ui-invariants.js (V3 contract).
 * This file is kept only because tailwind.config.js requires it at build time.
 * DO NOT add new imports of this file. Migrate to DESIGN_INTENTS tokens.
 */

export const tokens = {
    // ===== BRAND COLORS =====
    brand: {
        primary: 'var(--brand-primary, #191970)',        // Dynamic Authority
        primaryHover: 'var(--brand-primary-hover, #0F0F4D)',
        primaryLight: 'var(--brand-primary-light, #3B3F91)',
        primarySoft: 'var(--brand-primary-soft, #E5E7F5)',
    },

    // ===== SEMANTIC STATUS COLORS =====
    // Maps status meaning to colors (NOT positional)
    status: {
        accepted: {
            bg: 'hsl(var(--status-accepted-bg))',
            text: 'hsl(var(--status-accepted-text))',
            border: 'hsl(var(--status-accepted-border))',
            hover: 'hsl(var(--status-accepted-bg) / 0.8)',
        },
        rejected: {
            bg: 'hsl(var(--status-rejected-bg))',
            text: 'hsl(var(--status-rejected-text))',
            border: 'hsl(var(--status-rejected-border))',
            hover: 'hsl(var(--status-rejected-bg) / 0.8)',
        },
        pending: {
            bg: 'hsl(var(--status-pending-bg))',
            text: 'hsl(var(--status-pending-text))',
            border: 'hsl(var(--status-pending-border))',
            hover: 'hsl(var(--status-pending-bg) / 0.8)',
        },
        neutral: {
            bg: 'hsl(var(--status-neutral-bg, 0 0% 98%))',
            text: 'hsl(var(--status-neutral-text, 0 0% 40%))', // noscan
            border: 'hsl(var(--status-neutral-border, 0 0% 90%))',
            hover: 'hsl(var(--status-neutral-bg, 0 0% 98%) / 0.8)',
        },
        warning: {
            bg: 'hsl(var(--status-pending-bg))',
            text: 'hsl(var(--status-pending-text))',
            border: 'hsl(var(--status-pending-border))',
            hover: 'hsl(var(--status-pending-bg) / 0.8)',
        },
    },

    // ===== CANVAS & SURFACES =====
    canvas: {
        base: '#FAFAFB',           // Page background
        card: '#FFFFFF',           // Card background
        panel: '#F4F5F7',          // Secondary panels
    },

    // ===== TEXT COLORS =====
    text: {
        primary: 'hsl(var(--slate-700))',        // Main body text
        secondary: '#8E94A4',      // Secondary text, captions
        heading: 'var(--brand-primary, #191970)', // noscan — CSS var string, not a UI label
    },

    // ===== SPACING =====
    spacing: {
        xs: '0.5rem',    // 8px
        sm: '0.75rem',   // 12px
        md: '1rem',      // 16px
        lg: '1.5rem',    // 24px
        xl: '2rem',      // 32px
        '2xl': '3rem',   // 48px
    },

    // ===== TYPOGRAPHY =====
    typography: {
        fontFamily: {
            body: ['Inter', '-apple-system', 'BlinkMacSystemFont', 'sans-serif'],
            heading: ['DM Sans', '-apple-system', 'BlinkMacSystemFont', 'sans-serif'],
        },
        fontSize: {
            xs: '0.75rem',    // 12px
            sm: '0.875rem',   // 14px
            base: '1rem',     // 16px
            lg: '1.125rem',   // 18px
            xl: '1.25rem',    // 20px
            '2xl': '1.5rem',  // 24px
            '3xl': '1.875rem',// 30px
            '4xl': '2.25rem', // 36px
        },
        fontWeight: {
            normal: '400',
            medium: '500',
            semibold: '600',
            bold: '700',
        },
    },

    // ===== BORDERS & RADII =====
    borderRadius: {
        sm: '0.375rem',  // 6px
        md: '0.5rem',    // 8px
        lg: '0.75rem',   // 12px
        xl: '1rem',      // 16px
        full: '9999px',  // Full round
    },

    // ===== SHADOWS =====
    boxShadow: {
        sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
        lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    },
};

export default tokens;
